@if (formInitialized) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-fluid">
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Name'"
        [name]="'name'"
        [colSize]="6"
        [formField]="form.get('name')">
        <input
          pInputText
          id="name"
          type="text"
          formControlName="name"
          class="p-input" />
      </app-form-field-wrapper>

      <app-form-field-wrapper
        [label]="'Typ'"
        [name]="'type'"
        [colSize]="6"
        [formField]="form.get('type')">
        <p-dropdown
          [options]="types"
          id="type"
          formControlName="type"
          optionValue="value"
          optionLabel="label"
          placeholder="Typ auswählen">
          <ng-template let-selectedType pTemplate="selectedItem">
            <ng-container *ngIf="selectedType">
              <div class="flex align-items-center gap-3">
                <i class="w-1rem text-center" [class]="selectedType?.icon"></i>
                {{ selectedType?.label }}
              </div>
            </ng-container>
            <ng-container *ngIf="!selectedType"> Typ auswählen </ng-container>
          </ng-template>

          <ng-template let-type pTemplate="item">
            <div class="flex align-items-center gap-3">
              <i class="w-1rem text-center" [class]="type.icon"></i>
              {{ type.label }}
            </div>
          </ng-template>
        </p-dropdown>
      </app-form-field-wrapper>
    </div>
    <p-divider />
    <app-form-footer
      [cancelLevel]="cancelLevel"
      [showRemoveButton]="!!itemToEdit"
      [isEditMode]="!!itemToEdit"
      (cancel)="cancel.emit()"
      (removeClick)="
        itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
      "></app-form-footer>
  </form>
}
